import React from 'react';
import { Formik } from 'formik';
import * as yup from 'yup';
import FormikTextField from 'catalyst/core/form/TextField/variants/FormikTextField';
import Button from 'catalyst/core/Button';
import { Box, Grid } from '@material-ui/core';
import * as Yup from 'yup';

const validationSchema = {
    password: Yup.string().required('Verification is Required'),
};

const ReAuthenticationForm = ({ updateUser, initialValues }) => {
    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values, { setSubmitting }) => {
                setSubmitting(false);
                updateUser(values);
            }}
            validationSchema={yup.object(validationSchema)}
        >
            {({ submitForm, isSubmitting, errors, touched, values }) => {
                const submit = (event) => {
                    event.preventDefault();
                    submitForm();
                };
                return (
                    <Box style={{ minWidth: '300px', padding: '10px 24px' }}>
                        <FormikTextField
                            style={{ marginBottom: '10px' }}
                            id="password"
                            label="Please Confirm your Password"
                            name="password"
                            type="password"
                            variant="outlined"
                            fullWidth
                            error={errors.password}
                            touched={touched.password}
                            helperText={touched.password && errors.password}
                        />
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            type="submit"
                            onClick={submit}
                        >
                            Update Account
                        </Button>
                    </Box>
                );
            }}
        </Formik>
    );
};

export default ReAuthenticationForm;
